// Dependencies
import axios from 'axios'

// Services
import { getCookie, Auth } from "@/lib/cookie"

// Utils
import { Converter } from '../utils/converter'

/**
 * @typedef Province
 * @type {Object}
 * @property {String} code - Province code
 * @property {String} name - Province name
 */

/**
 * @typedef ProvinceResult
 * @type {Object}
 * @property {Number}     total - Total items
 * @property {Province[]} items - Province List
 */

/**
 * @typedef LocationFilter
 * @type {Object}
 * @property {String} text      - Search Text
 * @property {String} province  - Province Code
 * @property {Number} page      - Request Page
 * @property {Number} limit     - Request Limit
 */

/**
 * @typedef Location
 * @type {Object}
 * @property {String} zipCode       - Zip Code
 * @property {String} tumbonCode    - Tumbon Code
 * @property {String} tumbonPrefix  - Tumbon Prefix
 * @property {String} tumbonName    - Tumbon Name
 * @property {String} amphurCode    - Amphur Code
 * @property {String} amphurPrefix  - Amphur Prefix
 * @property {String} amphurName    - Amphur Name
 * @property {String} provinceName  - Province Code
 * @property {String} provinceCode  - Province Name
 */

/**
 * @typedef LocationResult
 * @type {Object}
 * @property {Number}     total - Total items
 * @property {Location[]} items - Location List
 */

/**
 * @typedef AddressState
 * @type {Object}
 * @property {ProvinceResult} province - Province Result
 */

export class ProjectAddress {

  // Request Endpoing
  static endpoint = (
    `${process.env.ADMIN_HOST}/ruejai-backend-admin/api/project/address`
  )

  /** @type {AddressState} */
  static state = {
    province: {
      total: 0, items: []
    },
  }

  static headers() {
    return {
      'Authorization': `Bearer ${getCookie(Auth.AccessToken)}`
    }
  }

  static has(data, key = 'result') {
    return Object.keys(data).includes(key)
  }

  /**
   * Fetch Province List
   * 
   * @returns {Promise<ProvinceResult>}
   */
  static async province() {

    // Request URL
    const url = this.endpoint + '/province'

    // Default Result
    let result = {
      total: 0, items: []
    }

    try {

      // State Props
      const { province } = this.state

      // Validate State
      if (province.total > 0) return province
      
      // Request Headers
      const headers = this.headers()

      // Request Province
      const { data } = await axios.get(
        url, { headers }
      )

      // Set Result
      if (this.has(data)) {
        
        // Set Result
        result = data.result
        
        // Set State
        this.state.province = result
      }
    }
    catch (error) {
      
      // Error Message
      const { message } = error
      
      // Error Message
      console.warn(
        'project-address.province', message
      )
    }

    return result
  }

  /**
   * Fetch Location List
   * 
   * @param {LocationFilter} params  - Filter parameters
   * @returns {Promise<ProvinceResult>}
   */
  static async location(params) {
    
    // Request URL
    const url = this.endpoint

    // Default Result
    let result = {
      total: 0, items: []
    }

    try {

      // Request Headers
      const headers = this.headers()

      // Fetch Province
      const { data } = await axios.get(
        url, { headers, params }
      )

      // Set Result
      if (this.has(data)) {
        result = Converter.key(data.result)
      }
    }
    catch (error) {
      
      // Error Message
      const { message } = error
      
      // Error Message
      console.warn(
        'project-address.province', message
      )
    }

    return result
  }
}


// WEBPACK FOOTER //
// ./src/clients/BackendAdminClient/project-address.js